import React, { RefObject } from 'react';

import cn from 'classnames';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';

import { Input } from '@shared/ui';

import cls from './AddEmployeeToTeam.module.css';
import { IFormValues } from '../model/types';

interface AddEmployerFieldsProps {
    control: Control<IFormValues>;
    errors: FieldErrors<IFormValues>;
    inputRef: RefObject<HTMLInputElement>;
    phoneInputWrapperRef: RefObject<HTMLDivElement>;
    t: (key: string) => string;
    enableTelephoneNotice: boolean;
}

export const AddEmployeeFields = ({
    control,
    errors,
    inputRef,
    phoneInputWrapperRef,
    t,
    enableTelephoneNotice,
}: AddEmployerFieldsProps) => (
    <>
        <Controller
            name="estimateUserRole"
            control={control}
            rules={{
                required: t('AddEmployerToTeam.Input.Error.EmptyField'),
                maxLength: { value: 255, message: t('AddEmployerToTeam.Input.Error.MaxLength') },
            }}
            render={({ field }) => (
                <Input
                    {...field}
                    label={t('AddEmployerToTeam.Input.EstimateUserRole.Label')}
                    error={errors.estimateUserRole?.message}
                    ref={inputRef}
                    inputErrorClassName={
                        errors.estimateUserRole?.message && cls.InputErrorClassName
                    }
                    placeholder={t('AddEmployerToTeam.Input.EstimateUserRole.Placeholder')}
                    autoFocus
                />
            )}
        />
        <Controller
            name="email"
            control={control}
            rules={{
                required: t('AddEmployerToTeam.Input.Error.EmptyField'),
                maxLength: { value: 64, message: t('AddEmployerToTeam.Input.Error.MaxLength') },
                pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: t('AddEmployerToTeam.Input.Error.IncorrectEmail'),
                },
            }}
            render={({ field }) => (
                <Input
                    {...field}
                    label={t('AddEmployerToTeam.Input.Email.Label')}
                    placeholder={t('AddEmployerToTeam.Input.Email.placeholder')}
                    inputClassName={cls.Input}
                    error={errors.email?.message}
                    errorClassName={cls.ErrorClassName}
                    inputErrorClassName={errors.email?.message && cls.InputErrorClassName}
                    type="email"
                />
            )}
        />
        {enableTelephoneNotice && (
            <Controller
                name="phone"
                control={control}
                rules={{
                    required: t('AddEmployerToTeam.Input.Error.EmptyField'),
                    maxLength: {
                        value: 255,
                        message: t('AddEmployerToTeam.Input.Error.MaxLength'),
                    },
                    minLength: { value: 12, message: t('AddEmployerToTeam.Input.Error.MinLength') },
                }}
                render={({ field, fieldState }) => (
                    <div className={cn(cls.phoneWrapper)} ref={phoneInputWrapperRef}>
                        <Input
                            label={t('AddEmployerToTeam.Input.Phone.Label')}
                            name="phone"
                            error={fieldState.error?.message}
                            inputClassName={cn(cls.Input)}
                            renderInput={(inputProps) => (
                                <PhoneInput
                                    {...inputProps}
                                    value={field.value ? field.value.replace(/^\+/, '') : ''}
                                    onChange={(val) => field.onChange(val ? `+${val}` : '')}
                                    disableDropdown
                                    inputProps={{
                                        name: 'phone',
                                        placeholder: '+7 (999) 999-99-99',
                                        id: inputProps.id ?? 'phone',
                                    }}
                                    inputClass={inputProps.className}
                                    containerClass={cls.reactPhoneInput}
                                    specialLabel=""
                                />
                            )}
                        />
                    </div>
                )}
            />
        )}
    </>
);
